import { EMedicalCategoryType } from '@/entities/medical-category';
import { parseMedicalCategoryCategoryTypeOf } from '@/parsers/common';
import { DiagnosisContactType, TelemedicineEligibleTargetType, TelemedicineTargetType } from '@/types/bff/gql-schema';
import { useNonF2fQuickDiagnosisDoctorQuery } from './doctor.gql.impl';

export interface QuickDiagnosisDoctorQueryParameter {
  medicalCategory: {
    type: EMedicalCategoryType;
    id: string;
  };
  contactType: string;
}

export interface QuickDiagnosisDoctorResult {
  doctorId: string;
  doctorPid: string;
  targetDate: string;
  startTimeSlotValue: number;
  endTimeSlotValue: number;
}

const useQuickDiagnosisDoctor = () => {
  const getQuickDiagnosisDoctorInfo = async (
    variables: QuickDiagnosisDoctorQueryParameter
  ): Promise<QuickDiagnosisDoctorResult> => {
    const data = await useNonF2fQuickDiagnosisDoctorQuery.fetcher({
      request: {
        medicalCategory: {
          type: parseMedicalCategoryCategoryTypeOf(variables.medicalCategory.type),
          id: variables.medicalCategory.id,
        },
        telemedicineEligibleTargetType: TelemedicineEligibleTargetType.AlwaysEligible,
      },
      telemedicineTargetType: TelemedicineTargetType.AlwaysEligible,
      contactType: DiagnosisContactType.NonF2F,
    })();

    const firstSchedule = data?.nonF2fQuickDiagnosisDoctor?.doctor.diagnosisBookingSchedules?.[0];
    const firstTimeSlot = firstSchedule?.schedules?.[0];

    return {
      doctorId: data?.nonF2fQuickDiagnosisDoctor?.doctor.doctorId || '',
      doctorPid: data?.nonF2fQuickDiagnosisDoctor?.doctor.doctorPublicId || '',
      targetDate: firstSchedule?.targetDate || '',
      startTimeSlotValue: firstTimeSlot?.startTimeSlot?.value || -1,
      endTimeSlotValue: firstTimeSlot?.endTimeSlot?.value || -1,
    };
  };

  return {
    getQuickDiagnosisDoctorInfo,
  };
};

export default useQuickDiagnosisDoctor;
